// Mock data for The LaShay & Silk Collective

export const businessInfo = {
  name: "The LaShay & Silk Collective",
  tagline: "Artisan Crafted, Nature Inspired",
  email: "lashayandsilkcoll@outlook.com",
  description: "Discover our curated collection of handcrafted treasures - from luxurious hair and skincare to gourmet delights and elegant home décor. Each piece is thoughtfully created with natural ingredients and timeless craftsmanship."
};

export const featuredCategories = [
  {
    id: 1,
    name: "Hair Care",
    description: "Natural botanical formulations for lustrous, healthy hair",
    image: "https://images.pexels.com/photos/10631912/pexels-photo-10631912.jpeg",
    products: 12
  },
  {
    id: 2,
    name: "Skin Care",
    description: "Organic skincare crafted with nature's finest ingredients",
    image: "https://images.pexels.com/photos/31110089/pexels-photo-31110089.png",
    products: 15
  },
  {
    id: 3,
    name: "Baked Goods",
    description: "Fresh artisan baked treats made with love",
    image: "https://images.unsplash.com/photo-1588168333986-5078d3ae3976",
    products: 20
  },
  {
    id: 4,
    name: "Gourmet Chocolates",
    description: "Handcrafted chocolates with exquisite flavors",
    image: "https://images.unsplash.com/photo-1621134283184-5e7881013013",
    products: 18
  },
  {
    id: 5,
    name: "Wine Collection",
    description: "Curated selection of fine wines",
    image: "https://images.unsplash.com/photo-1707289516284-c51cf57d22fa",
    products: 10
  },
  {
    id: 6,
    name: "Holiday Décor",
    description: "Elegant decorations for festive celebrations",
    image: "https://images.unsplash.com/photo-1762459989947-4ace093a470e",
    products: 25
  },
  {
    id: 7,
    name: "Garden Décor",
    description: "Beautiful accents for your outdoor sanctuary",
    image: "https://images.unsplash.com/photo-1735964528533-e3cf139bbd7d",
    products: 16
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Emily Richardson",
    comment: "The hair care products transformed my hair! Natural, effective, and beautifully packaged.",
    rating: 5,
    location: "Portland, OR"
  },
  {
    id: 2,
    name: "Michael Chen",
    comment: "The gourmet chocolates are absolutely divine. Perfect gifts for special occasions!",
    rating: 5,
    location: "Seattle, WA"
  },
  {
    id: 3,
    name: "Sarah Williams",
    comment: "I love supporting local artisans. The quality and care in every product is evident.",
    rating: 5,
    location: "San Francisco, CA"
  },
  {
    id: 4,
    name: "David Martinez",
    comment: "The garden décor pieces have completely elevated my outdoor space. Stunning!",
    rating: 5,
    location: "Austin, TX"
  }
];

export const aboutInfo = {
  title: "Our Story",
  content: "The LaShay & Silk Collective was born from a passion for creating beautiful, handcrafted products that celebrate nature's bounty and timeless artisan traditions. Every item in our collection is carefully crafted with premium natural ingredients and attention to detail that honors both heritage and innovation.",
  values: [
    {
      title: "Handcrafted Excellence",
      description: "Each product is made with meticulous attention to detail"
    },
    {
      title: "Natural Ingredients",
      description: "We source the finest organic and natural materials"
    },
    {
      title: "Sustainable Practices",
      description: "Committed to eco-friendly production methods"
    }
  ]
};
